import React, { FC } from 'react';

import ManualSelect from './selects/ManualSelect';
import { IAttributionItem } from '../../../../../app/types/filter';

interface IAttributionProps {
    items: IAttributionItem[],
    isDashboard?: boolean;
    isModalDashboard?: boolean;
}

const Attribution: FC<IAttributionProps> = ({ items, isDashboard, isModalDashboard }) => {
    const isDashboardAttributes = items.some((el)=>el.selectValues.some((element)=>element.id === 'blocks'));
    return (
        <>
            {items.map((item, index) => (
                <ManualSelect
                    key={index}
                    id={item.id}
                    name={item.name}
                    selectValues={item.selectValues}
                    description={item.description}
                    icon={item.icon}
                    isDashboardAttributes={isDashboard ?? isDashboardAttributes}
                    isModalDashboard={isModalDashboard}
                />
            ))}
        </>
    );
};

export default Attribution;
